/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Browser UTC offset in hours (e.g. -3 for America/Sao_Paulo), same convention
// as the native reports: the backend buckets days in the viewer's local day.
const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class VinctoDashboardAPI extends ApiClient {
  constructor() {
    super('vincto/dashboard', { accountScoped: true, apiVersion: 'v1' });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params: { ...params, timezone_offset: getTimeOffset() },
    });
  }

  // Aba Atendimento do Painel geral: por caixa e lista de espera.
  service(params = {}) {
    return axios.get(`${this.url}/service`, {
      params: { ...params, timezone_offset: getTimeOffset() },
    });
  }

  // Aba Atividades do Painel geral: atrasadas, hoje e concluidas, por pessoa.
  activities(params = {}) {
    return axios.get(`${this.url}/activities`, {
      params: { ...params, timezone_offset: getTimeOffset() },
    });
  }
}

export default new VinctoDashboardAPI();
